<template>
  <div v-if="colors" :class="$style['product-color-stack']">
    <Color
      v-for="(color, index) in filteredColors"
      :key="'color' + index"
      :show-icon="false"
      :style="{ 'z-index': colors.length - index }"
      small
      tab-index="-1"
      :color="color" />
    <span
      v-if="colors.length > filteredColors.length"
      :class="$style['product-color-stack__more']">
      +{{ colors.length - filteredColors.length }}
    </span>
  </div>
</template>
<script setup>

const props = defineProps({
  colors: {
    type: [Object, Array],
    default: null
  }
})
const filteredColors = computed(() => {
  return props.colors.filter((color, index) => {
    return index < 6
  })
})
</script>
<style lang="scss" module>
.product-color-stack {
  display: flex;
  align-items: center;
  margin-top: $spacing * 0.5;
  width: 100%;
  position: relative;
  z-index: 1;

  &__more {
    border: 1px solid transparent; // To match color component
    color: $grey-dark;
    font-size: $font-size-xxxs;
    height: $spacing * 1.5;
    width: $spacing * 1.5;
    margin-left: 2px;
    border-radius: 100%;
    line-height: 1;
  }
}
</style>
